module.exports = __webpack_public_path__ + "img/4.48749b7b.png";